export const MaxCount = {
  Team: 200,
  Group: 100,
}
